export const PAGE_SIZE = [10, 20, 50, 100, 200, 500]
export const DEFAULT_PAGE_SIZE = 20
export const PAGINATION = {
  pageSize: 20,
  currentPage: 1,
  textSearch: "",
}
